<!-- This component represents the Low Confidence Tag, which is used to indicate fields with low extraction confidence. -->

<div
  class="low-tag"
  (click)="openPopover($event)"
  (keydown.enter)="openPopover($event)"
>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1787_473)">
      <path
        d="M2.25 11V8.5M2.25 3.5V1M1 2.25H3.5M1 9.75H3.5M6.5 1.5L5.6329 3.75443C5.4919 4.12104 5.4214 4.30435 5.31175 4.45854C5.2146 4.5952 5.0952 4.71459 4.95854 4.81176C4.80435 4.9214 4.62104 4.9919 4.25443 5.1329L2 6L4.25443 6.8671C4.62104 7.0081 4.80435 7.0786 4.95854 7.18825C5.0952 7.2854 5.2146 7.4048 5.31175 7.54145C5.4214 7.69565 5.4919 7.87895 5.6329 8.24555L6.5 10.5L7.3671 8.24555C7.5081 7.87895 7.5786 7.69565 7.68825 7.54145C7.7854 7.4048 7.9048 7.2854 8.04145 7.18825C8.19565 7.0786 8.37895 7.0081 8.74555 6.8671L11 6L8.74555 5.1329C8.37895 4.9919 8.19565 4.9214 8.04145 4.81176C7.9048 4.71459 7.7854 4.5952 7.68825 4.45854C7.5786 4.30435 7.5081 4.12104 7.3671 3.75443L6.5 1.5Z"
        stroke="#FA0000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1787_473">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <span>Low</span>
</div>

<!-- popover template -->
<ng-template #popoverContent>
  <div
    class="popover"
    [ngClass]="[popoverPosition.vertical, popoverPosition.horizontal]"
  >
    <div class="popover-header horizontal-line">
      <div class="header-left">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="18"
            height="18"
            rx="4"
            fill="url(#paint0_linear_1818_2660)"
          />
          <g clip-path="url(#clip0_1818_2660)">
            <path
              d="M11.6667 13.0003C12.0203 13.0003 12.3594 13.1408 12.6095 13.3909C12.8595 13.6409 13 13.98 13 14.3337C13 13.98 13.1405 13.6409 13.3905 13.3909C13.6406 13.1408 13.9797 13.0003 14.3333 13.0003C13.9797 13.0003 13.6406 12.8599 13.3905 12.6098C13.1405 12.3598 13 12.0206 13 11.667C13 12.0206 12.8595 12.3598 12.6095 12.6098C12.3594 12.8599 12.0203 13.0003 11.6667 13.0003ZM11.6667 5.00033C12.0203 5.00033 12.3594 5.1408 12.6095 5.39085C12.8595 5.6409 13 5.98004 13 6.33366C13 5.98004 13.1405 5.6409 13.3905 5.39085C13.6406 5.1408 13.9797 5.00033 14.3333 5.00033C13.9797 5.00033 13.6406 4.85985 13.3905 4.6098C13.1405 4.35975 13 4.02061 13 3.66699C13 4.02061 12.8595 4.35975 12.6095 4.6098C12.3594 4.85985 12.0203 5.00033 11.6667 5.00033ZM7 13.0003C7 11.9395 7.42143 10.922 8.17157 10.1719C8.92172 9.42175 9.93913 9.00033 11 9.00033C9.93913 9.00033 8.92172 8.5789 8.17157 7.82875C7.42143 7.07861 7 6.06119 7 5.00033C7 6.06119 6.57857 7.07861 5.82843 7.82875C5.07828 8.5789 4.06087 9.00033 3 9.00033C4.06087 9.00033 5.07828 9.42175 5.82843 10.1719C6.57857 10.922 7 11.9395 7 13.0003Z"
              stroke="white"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1818_2660"
              x1="5.52273"
              y1="4.09091"
              x2="21.2727"
              y2="18"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#CA43FB" />
              <stop offset="1" stop-color="#3C31DB" />
            </linearGradient>
            <clipPath id="clip0_1818_2660">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(1 1)"
              />
            </clipPath>
          </defs>
        </svg>
        <b>Low Confidence</b>
      </div>
      <div class="header-right confidence-tag">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1787_473)">
            <path
              d="M2.25 11V8.5M2.25 3.5V1M1 2.25H3.5M1 9.75H3.5M6.5 1.5L5.6329 3.75443C5.4919 4.12104 5.4214 4.30435 5.31175 4.45854C5.2146 4.5952 5.0952 4.71459 4.95854 4.81176C4.80435 4.9214 4.62104 4.9919 4.25443 5.1329L2 6L4.25443 6.8671C4.62104 7.0081 4.80435 7.0786 4.95854 7.18825C5.0952 7.2854 5.2146 7.4048 5.31175 7.54145C5.4214 7.69565 5.4919 7.87895 5.6329 8.24555L6.5 10.5L7.3671 8.24555C7.5081 7.87895 7.5786 7.69565 7.68825 7.54145C7.7854 7.4048 7.9048 7.2854 8.04145 7.18825C8.19565 7.0786 8.37895 7.0081 8.74555 6.8671L11 6L8.74555 5.1329C8.37895 4.9919 8.19565 4.9214 8.04145 4.81176C7.9048 4.71459 7.7854 4.5952 7.68825 4.45854C7.5786 4.30435 7.5081 4.12104 7.3671 3.75443L6.5 1.5Z"
              stroke="#FA0000"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <rect width="12" height="12" fill="white" />
          </defs>
        </svg>
        <span>{{ toPercentage(confidenceScore) }} Confidence</span>
      </div>
      <div
        class="close-popover"
        (click)="closePopover()"
        (keydown.enter)="closePopover()"
      >
        X
      </div>
    </div>
    <div class="popover-body">
      This field was detected with low extraction confidence. Please review it
      against the original document.
    </div>
    <div class="popover-footer">
      <button class="mmp-btn-secondary" (click)="markCorrect()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1818_2673)">
            <path
              d="M1.9165 7.00004L4.83317 9.91671L10.6665 4.08337"
              stroke="#006580"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1818_2673">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Mark as Correct
      </button>
    </div>
  </div>
</ng-template>
